
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectWithoutLabel: {
    id: "ProjectWithout.label",
    defaultMessage: "Yes, I´d like to proceed without an object",
  },
  projectWithoutLabelButton: {
    id: "ProjectWithout.button",
    defaultMessage: "Accept",
  },
});

export default MESSAGES;